import { render, staticRenderFns } from "./CommonExampleDocTypeGroup.vue?vue&type=template&id=5e48f502"
import script from "./CommonExampleDocTypeGroup.vue?vue&type=script&lang=js"
export * from "./CommonExampleDocTypeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports